(function( $ ) {

    $(document).ready(function () {
        [].forEach.call(document.querySelectorAll('.carousel-image__wrapper'), function (el) {
            tns({
                container: el,
                mode: 'gallery',
                items: 1,
                controlsText: ["",""],
                speed: 2000,
                autoplay: true,
                autoplayTimeout: 7000,
                autoplayHoverPause: false,
                autoplayButtonOutput: false,
                autoplayResetOnVisibility: true
            });
        });
    });

})( jQuery );